import React, { forwardRef } from "react";
import BannerImg from "../Assets/images/banner-right-img.png";
import StyleModulePopup from "./StyleModulePopup";
import Doller from "../Assets/images/doller.png";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  useAccount,
  useConnect,
  useDisconnect,
  useEnsAvatar,
  useEnsName,
} from "wagmi";
import { useState } from "react";
import { getInputValue } from "../redux/counterSlice";
import { useEffect } from "react";
import Web3 from "web3";
import { updateCategory } from "../redux/counterSlice";
import Popup from "./Popup";
import PaymentModal from "./Modals/PaymentModal.js";
import swal from "sweetalert";
function GenerateAiArt() {
  const { address, connector, isConnected } = useAccount();
  const [getData, setGetData] = useState([]);
  const [counter, setCounter] = useState(1);
  const [inputValue, setInputValue] = useState("");
  const [flag, setFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const categories = useSelector((state) => state.categories);
  const [credits, setCredits] = useState(0);
  console.log("inputValue ", inputValue);
  const getSeletedValue = useSelector((state) =>
    state.categories.filter((data) => data.status == true).map((data) => data)
  );

  let getCategories = categories.map(function (value, label) {
    return value;
  });

  const generateImages = async () => {
    const postData = {
      walletAddress: address,
      imageQuantity: counter,
    };
    await axios
      .post(
        `https://www.apis.foundationmixer.com/nfts/generateImages`,
        postData
      )
      .then((response) => {
        console.log("response generate images ", response);
        if (response.status === 200) {
          console.log("data updated!");
        }
      })
      .catch((error) => {
        swal(error.response.data.data);
      });
  };

  const getcategorywisedata = async (data, inputValue) => {
    if (
      getSeletedValue[0]?.name == "dream" ||
      getSeletedValue[0]?.name == "colorizer"
    ) {
      setLoader(true);
      await axios
        .post(
          `https://rjcemp9a8a.execute-api.us-east-2.amazonaws.com/dev/nftaiapi`,
          {
            text: "cute animals with red hat green hair yellow sunglasses beach background",
            type: data,
            width: "450",
            height: "450",
            picture_url: inputValue,
          }
        )
        .then(function (response) {
          console.log("generate images response if block ", response);
          setGetData((prev) => [...prev, response.data]);
          if (!response.data.errorType) {
            generateImages();
          } else {
            swal("Technical Error Occurred! Please Try Again!");
          }
          setLoader(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setLoader(true);
      await axios
        .post(
          `https://rjcemp9a8a.execute-api.us-east-2.amazonaws.com/dev/nftaiapi`,
          {
            text: inputValue,
            type: data,
            width: "450",
            height: "450",
            picture_url:
              "https://nftai.s3.amazonaws.com/img/IMG-20221211-WA0010.jpg",
          }
        )
        .then(function (response) {
          console.log("generate images response else block ", response);
          setGetData((prev) => [...prev, response.data]);
          if (!response.data.errorType) {
            generateImages();
          } else {
            swal("Technical Error Occurred! Please Try Again!");
          }
          setLoader(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const getcategorywisedatas = async (data, inputValue) => {
    // if (
    //   getSeletedValue[0]?.name == "dream" ||
    //   getSeletedValue[0]?.name == "colorizer"
    // ) {
    //   setLoader(true);
    //   await axios
    //     .post(
    //       `http://localhost:5000/image-view`,
    //       {
    //         text: "cute animals with red hat green hair yellow sunglasses beach background",
    //         type: data,
    //         width: "450",
    //         height: "450",
    //         picture_url: inputValue,
    //       }
    //     )
    //     .then(function (response) {
    //       console.log("generate images response if block ", response);
    //       setGetData((prev) => [...prev, response.data]);
    //       if (!response.data.errorType) {
    //         generateImages();
    //       } else {
    //         swal("Technical Error Occurred! Please Try Again!");
    //       }
    //       setLoader(false);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // } else {
    setLoader(true);
    const datas = {
      text: inputValue,
      counter: counter,
      width: "450px",
      height: "450px",
    };

    await axios
      .post(`http://localhost:5000/image-view`, datas)
      .then(function (response) {
        console.log("generate images response else block ", response);
        setGetData(response.data.data);

        // if (!response.data.errorType) {
        //   generateImages();
        // } else {
        //   swal("Technical Error Occurred! Please Try Again!");
        // }
        setLoader(false);
      })
      .catch(function (error) {
        console.log(error);
      });
    // }
  };

  const handleClick = () => {
    setGetData([]);

    if (
      (inputValue.length > 0 && credits >= 0.25 && counter === 1) ||
      (inputValue.length > 0 && credits >= 1 && counter === 4) ||
      (inputValue.length > 0 && credits >= 10 && counter === 40)
    ) {
      // if (getSeletedValue.length == 0) {
      //   alert("Please select Style ");
      //   return false;
      // }

      // const loop = counter == 1 || counter == 4 ? 1 : counter;
      // for (let index = 0; index < loop; index++) {
      //   getSeletedValue.map((curVal) => {
      getcategorywisedatas("", inputValue);
      //   });
      // }
    } else {
      swal("Please Enter Prompt OR Insufficient Credits!");
    }
  };

  const checkClick = () => {
    // window.ethereum.request({
    //     method: "eth_requestAccounts",
    // });
    setFlag(true);
  };

  const getCredits = async () => {
    const result = await axios.get(
      `https://www.apis.foundationmixer.com/nfts/getCredits/?walletAddress=${address}`
    );
    if (result.status === 200) {
      setCredits(result.data.credits);
    }
  };

  useEffect(() => {
    getCredits();
  });

  // useEffect(() => {
  //     const handleContextmenu = e => {
  //         e.preventDefault()
  //     }
  //     document.addEventListener('contextmenu', handleContextmenu)
  //     return function cleanup() {
  //         document.removeEventListener('contextmenu', handleContextmenu)
  //     }
  // }, [])

  const handleMetaMaskOpen = async () => {
    // if (window.ethereum) {
    // await window.ethereum.request({
    //     method: "eth_requestAccounts",
    // });
    // }
  };

  return (
    <>
      {/* <section className={`mainSection ${openModal && "blur"}`}>
        <div className="container">
          <div className="row firstSection">
            <div className="col-md-6 col-sm-12 bannerLeft">
              <h2 className="title">Generate AI Art </h2>
              <h5 className="subText">
                Generate AI art simply by describing what you want to see and
                make it your own. Save as many images as you want.
              </h5>
              <div className="bannerBtnSect mt-50 mb-50">
                <a href="#mainSec" className="btn">
                  Start Generating
                </a>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <img style={{ width: "100%" }} src={BannerImg} />
            </div>
          </div>
        </div>
      </section> */}

      <section className="" style={{marginTop:"100px"}}>
        <div className={`container ${openModal && "blur"}`}>
          <div className="bg-gray gdfgh align-center">
            <h3>Total Cost: 10$ USD = 100 Credits</h3>
            <small>
              You have 5 credits, Buy credits to generate more images.
            </small>
            <small style={{ color: "#DA37D5", display: "block" }}>
              1 Credits = 0.10 USD
            </small>
            <button
              className={`btn mt-20`}
              onClick={() => {
                handleMetaMaskOpen();
                setOpenModal((value) => !value);
              }}
            >
              Buy Credits
            </button>
          </div>
        </div>
        <div>
          <PaymentModal open={openModal} onClose={() => setOpenModal(false)} />
        </div>
      </section>
    
      {/* <StyleModulePopup /> */}
      <Popup flag={flag} setFlag={() => setFlag((prev) => !prev)} />
    </>
  );
}

export default GenerateAiArt;
